// src/pages/payment/PaymentSuccessPage.jsx
import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import '../../styles/cart/PaymentSuccessPage.css';

const PaymentSuccessPage = () => {
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    // Get Stripe session ID
    const stripeSessionId = searchParams.get('session_id');
    setSessionId(stripeSessionId);

    // Clear cart once (safe on refresh)
    clearCart();

    // Optional cleanup
    sessionStorage.removeItem('shippingData');

    const timer = setTimeout(() => {
      setLoading(false);
    }, 800); // Smooth UX

    return () => clearTimeout(timer);
  }, [clearCart, searchParams]);

  if (loading) {
    return (
      <div className="payment-success-page">
        <div className="container">
          <LoadingSpinner />
          <p>Finalizing your order...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="container">
        <div className="success-card">
          <h1>Payment Successful 🎉</h1>
          <p>Thank you for your purchase!</p>

          {sessionId && (
            <p className="order-id">
              Stripe Session ID: <strong>{sessionId.slice(0, 12)}...</strong>
            </p>
          )}

          <p>
            Your order has been received and is being processed.
            A confirmation email will be sent shortly.
          </p>

          <div className="success-actions">
            <Link to="/shop" className="btn-shop">
              Continue Shopping
            </Link>
            <Link to="/" className="btn-home">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
